export class AddSocialNetworkSuccess {
    static readonly type = '[User] AddSocialNetworkSuccess';

    constructor(public payload: string) {}
}
